// src/services/api/config.ts

import { ENV } from '../../../config/environment';

export interface ApiConfig {
  baseURL: string;
  timeout: number;
  useMock: boolean;
  mockDelay: number;
}

// Configuration that can be easily switched between mock and real API
export const apiConfig: ApiConfig = {
  baseURL: ENV.API_BASE_URL,
  timeout: 10000,
  useMock: ENV.USE_MOCK,
  mockDelay: ENV.MOCK_DELAY,
};

// API endpoints - updated to match backend structure
export const endpoints = {
  auth: {
    login: '/auth/login',
    refresh: '/auth/refresh',
    logout: '/auth/logout',
    me: '/users/me',
  },
  users: {
    list: '/users',
    byId: (id: number) => `/users/${id}`,
    update: (id: number) => `/users/${id}`,
    me: '/users/me',
    employeeNames: '/users/employee-names',
  },
  projects: {
    list: '/projects/',
    create: '/projects/',
    byId: (id: number) => `/projects/${id}/`,
    update: (id: number) => `/projects/${id}/`,
    complete: (id: number) => `/projects/${id}/complete`,
    delete: (id: number) => `/projects/${id}/`,
    assign: (projectId: number, employeeId: number) => `/projects/${projectId}/assign/${employeeId}/`,
    tasks: '/tasks/',
  },
  tasks: {
    list: '/tasks/',
    create: '/tasks/',
    byId: (id: number) => `/tasks/${id}/`,
    update: (id: number) => `/tasks/${id}/`,
    delete: (id: number) => `/tasks/${id}/`,
    byUser: (userId: number) => `/tasks/?user_id=${userId}`,
    weekly: '/tasks/weekly',
    timeEntries: (taskId: number) => `/time-entries/?task_id=${taskId}`,
  },
  activityTypes: {
    byProject: (projectId: number) => `/activity-types/project/${projectId}`,
    create: '/activity-types/',
    update: (id: number) => `/activity-types/${id}`,
    delete: (id: number) => `/activity-types/${id}`,
  },
  timeEntries: {
    list: '/time-entries/',
    create: '/time-entries/',
    byId: (id: number) => `/time-entries/${id}/`,
    update: (id: number) => `/time-entries/${id}/`,
    delete: (id: number) => `/time-entries/${id}/`,
    byUser: '/time-entries/',
    daily: (date: string) => `/time-entries/daily/${date}/`,
  },
  reports: {
    weekly: '/reports/weekly',
    project: (projectId: number) => `/reports/project/${projectId}`,
    employee: (userId: number) => `/reports/employee/${userId}`,
  },
} as const;
